import React from 'react';
import './Heading.css';

const HeadingSection = () => {
  return (
    <div className="heading-section">
      <h2 className="main-heading">CAR FOR EVERY BUDGET</h2>
      <h2 className="heading">Airport Trip Pickup Will Be Charged in Advance</h2>
      <h2 className="heading">Rates Can Vary in Ramadan Month</h2>
    </div>
  );
};

export default HeadingSection;
